import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { immerable } from 'immer';
import { OrderedSet } from 'immutable';

import { DcCoreElementType } from '../../../core/dc-core-types';
import {
	IMetadataEntity,
	IProjectEntity,
} from '../../../ui/components/metadata.interface';

interface IMetadataItemEntity extends IMetadataEntity {
	project: IProjectEntity;
	tags: OrderedSet<AppTagItemEntity>;
	type: DcCoreElementType;
	typeDescription: string;
	sourceUrl: string;
}

const entityDefaults: IMetadataItemEntity = {
	id: -1,
	title: '',
	label: '',
	description: '',
	isActive: true,
	code: '',
	createdBy: '',
	updatedBy: '',
	creationDate: -1,
	updateDate: -1,
	iconId: -1,
	tags: OrderedSet(),
	type: DcCoreElementType.UNKNOWN,
	typeDescription: '',
	sourceUrl: '',
	project: {
		id: -1,
		isPublic: false,
		metadata: {
			label: '',
			title: '',
		},
	},
};

export class MetadataItemEntity implements IMetadataItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public title = entityDefaults.title;
	public description = entityDefaults.description;
	public isActive = entityDefaults.isActive;
	public code = entityDefaults.code;
	public createdBy = entityDefaults.createdBy;
	public updatedBy = entityDefaults.updatedBy;
	public creationDate = entityDefaults.creationDate;
	public updateDate = entityDefaults.updateDate;
	public iconId = entityDefaults.iconId;
	public project = entityDefaults.project;
	public label = entityDefaults.title;
	public tags = entityDefaults.tags;
	public type = entityDefaults.type;
	public typeDescription = entityDefaults.typeDescription;
	public sourceUrl = entityDefaults.sourceUrl;

	public static build(
		params: Partial<IMetadataItemEntity> = {}
	): MetadataItemEntity {
		const instance = new MetadataItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.title = params.title ?? entityDefaults.title;
		instance.description = params.description ?? entityDefaults.description;
		instance.isActive = params.isActive ?? entityDefaults.isActive;
		instance.code = params.code ?? entityDefaults.code;
		instance.createdBy = params.createdBy ?? entityDefaults.createdBy;
		instance.updatedBy = params.updatedBy ?? entityDefaults.updatedBy;
		instance.creationDate = params.creationDate ?? entityDefaults.creationDate;
		instance.updateDate = params.updateDate ?? entityDefaults.updateDate;
		instance.iconId = params.iconId ?? entityDefaults.iconId;
		instance.project = params.project ?? entityDefaults.project;
		instance.tags = params.tags ?? entityDefaults.tags;
		instance.type = params.type ?? entityDefaults.type;
		instance.typeDescription =
			params.typeDescription ?? entityDefaults.typeDescription;
		instance.label = instance.title;
		instance.sourceUrl = params.sourceUrl ?? entityDefaults.sourceUrl;
		return instance;
	}
}
